import { render } from "./NumberBlock.vue?vue&type=template&id=3374c6e0&scoped=true&ts=true"
import script from "./NumberBlock.vue?vue&type=script&lang=ts"
export * from "./NumberBlock.vue?vue&type=script&lang=ts"

import "./NumberBlock.vue?vue&type=style&index=0&id=3374c6e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3374c6e0"]])

export default __exports__